import { render, staticRenderFns } from "./TicketsDashboardHeader.vue?vue&type=template&id=cfd64042&scoped=true&"
import script from "./TicketsDashboardHeader.vue?vue&type=script&lang=ts&"
export * from "./TicketsDashboardHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TicketsDashboardHeader.vue?vue&type=style&index=0&id=cfd64042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd64042",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VRow,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfd64042')) {
      api.createRecord('cfd64042', component.options)
    } else {
      api.reload('cfd64042', component.options)
    }
    module.hot.accept("./TicketsDashboardHeader.vue?vue&type=template&id=cfd64042&scoped=true&", function () {
      api.rerender('cfd64042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/dashboard/components/TicketsDashboardHeader.vue"
export default component.exports